import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function GlobalAuditLogs() {
  return (
    <Page
      title='Global Audit Logs'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'Audit Logs',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/global-audit-logs',
  component: GlobalAuditLogs,
  type: 'auth',
});
